export const shouldShowUnlockMenuItem = (isLocked: boolean, hasEditPermission: boolean): boolean =>
  isLocked && hasEditPermission

export const shouldShowUnlockReportedWarning = (isReported: boolean): boolean => isReported

export const isUnlockButtonDisabled = (
  hasConfirmedUnlock: boolean,
  isUnlockPending: boolean,
  hasLockedAccountingPeriod: boolean
): boolean => !hasConfirmedUnlock || isUnlockPending || hasLockedAccountingPeriod
